import styled from 'styled-components'

export const Container = styled.div`
    display: flex;
    flex-direction: column;

    ul{
        list-style: none;
    }

    li{
        display: flex;
        justify-content: space-between;
        align-items: center;

        border: 1px solid #e8eaed;
        flex-direction: row;
        height: 35px;
        padding: 5px;
        padding-left: 10px;
        border-radius: 5px;
        font-weight: 600;
    }

    .field{
        width: 25%;
        display: flex;
        justify-content: 'center'
    }

    .header{
        font-weight: 800;
    }


`
